// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var QueryString = require("query-string");
var UseQueryParams = require("use-query-params");

function withHiddenDefault(m, $$default) {
  var M = UseQueryParams.withDefault(m, $$default);
  var encode = function (x) {
    if (x === $$default) {
      return ;
    } else {
      return M.encode(x);
    }
  };
  return {
          encode: encode,
          decode: M.decode
        };
}

function hide(m) {
  return m;
}

var stringParam = UseQueryParams.StringParam;

var numberParam = UseQueryParams.NumberParam;

var arrayParam = UseQueryParams.ArrayParam;

var booleanParam = UseQueryParams.BooleanParam;

function Make(M) {
  var use = function () {
    var match = UseQueryParams.useQueryParams(M.config);
    var setState = match[1];
    var setState$p = function (updateType, s) {
      setState(s, updateType);
    };
    return [
            match[0],
            setState$p
          ];
  };
  var encode = function (params) {
    return UseQueryParams.encodeQueryParams(M.config, params);
  };
  return {
          use: use,
          encode: encode
        };
}

function Make$1(M) {
  var use = function (key) {
    var match = UseQueryParams.useQueryParam(key, M);
    var setState = match[1];
    var setState$p = function (updateType, s) {
      setState(s, updateType);
    };
    return [
            match[0],
            setState$p
          ];
  };
  return {
          use: use
        };
}

var UseQueryParam = {
  Make: Make$1
};

var QueryString$1 = {
  stringify: (function (prim) {
      return QueryString.stringify(prim);
    })
};

function encodeDelimitedArray(prim0, prim1) {
  return UseQueryParams.encodeDelimitedArray(prim0, prim1);
}

function decodeDelimitedArray(prim0, prim1) {
  return UseQueryParams.decodeDelimitedArray(prim0, prim1);
}

function ParamConfigs_withDefault(prim0, prim1) {
  return UseQueryParams.withDefault(prim0, prim1);
}

var ParamConfigs = {
  stringParam: UseQueryParams.StringParam,
  numberParam: UseQueryParams.NumberParam,
  arrayParam: UseQueryParams.ArrayParam,
  booleanParam: UseQueryParams.BooleanParam,
  withDefault: ParamConfigs_withDefault,
  withHiddenDefault: withHiddenDefault
};

var UseQueryParams_ParamConfigs = {
  stringParam: stringParam,
  numberParam: numberParam,
  arrayParam: arrayParam,
  booleanParam: booleanParam,
  fromParamConfig: hide
};

var UseQueryParams$1 = {
  ParamConfigs: UseQueryParams_ParamConfigs,
  Make: Make
};

exports.QueryString = QueryString$1;
exports.encodeDelimitedArray = encodeDelimitedArray;
exports.decodeDelimitedArray = decodeDelimitedArray;
exports.ParamConfigs = ParamConfigs;
exports.UseQueryParams = UseQueryParams$1;
exports.UseQueryParam = UseQueryParam;
/* stringParam Not a pure module */
